import { useState } from 'react';
import { Link } from 'react-router-dom';
import { RiShoppingBasket2Fill } from 'react-icons/ri';
import { BiBowlHot, BiUser } from 'react-icons/bi';
import { MdMenuBook, MdOutlineEventNote } from 'react-icons/md';
import { BsBoxes, BsWallet2 } from 'react-icons/bs';
import {
    AiOutlineLineChart,
    AiOutlineMenu,
    AiOutlineClose
} from 'react-icons/ai';
import { MdOutlineAttachMoney } from "react-icons/md";
import { useAuth } from '../../auth/AuthenticationWrapper';

const TopMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const { user, hasPermission } = useAuth();
    const storedRole = sessionStorage.getItem('role');
    const storedLogin = sessionStorage.getItem('login');

    const effectiveRole = user?.role || storedRole || '';
    const effectiveLogin = user?.login || storedLogin || '';

    let userRole = effectiveRole;
    if (['ADMIN', 'CASHIER', 'ATTENDANT'].includes(userRole)) {
        userRole = 'OPERATIONAL';
    }

    const canViewOrders = hasPermission ? hasPermission("orders", "view") : false;
    const canViewSales = hasPermission ? hasPermission("sales", "view") : false;
    const canViewMenu = hasPermission ? hasPermission("menu", "view") : false;
    const canViewStorage = hasPermission ? hasPermission("storage", "view") : false;
    const canViewCustomers = hasPermission ? hasPermission("customers", "view") : false;
    const canViewFinancial = hasPermission ? hasPermission("financial", "view") : false;
    const canViewReservations = hasPermission ? hasPermission("reservations", "view") : false;
    const canViewWallet = hasPermission ? hasPermission("wallet", "view") : false;
    const asaasEnabled = user?.asaasEnabled || false;

    const menuItemsByRole = {
        OPERATIONAL: [
            { icon: <BiBowlHot size={24} />, color: 'bg-custom_red', title: 'Fila de Pedidos', to: '/pedidos', disabled: !canViewOrders },
            { icon: <RiShoppingBasket2Fill size={24} />, color: 'bg-custom_red', title: 'Novo Pedido', to: '/vendas', disabled: !canViewSales },
            { icon: <MdOutlineEventNote size={24} />, color: 'bg-custom_red', title: 'Reservas', to: '/reservas', disabled: !canViewReservations },
            { icon: <MdMenuBook size={24} />, color: 'bg-custom_blue', title: 'Cardápio', to: '/cardapio', disabled: !canViewMenu },
            { icon: <BsBoxes size={24} />, color: 'bg-custom_blue', title: 'Estoque', to: '/estoque', disabled: !canViewStorage },
            { icon: <BiUser size={24} />, color: 'bg-custom_green', title: 'Clientes', to: '/clientes', disabled: !canViewCustomers },
            { icon: <AiOutlineLineChart size={24} />, color: 'bg-custom_yellow', title: 'Financeiro', to: '/financeiro', disabled: !canViewFinancial },
            ...(asaasEnabled ? [{ icon: <BsWallet2 size={24} />, color: 'bg-custom_yellow', title: 'Carteira Digital', to: '/carteira-digital', disabled: !canViewWallet }] : []),
        ],
        STUDENT: [
            { icon: <RiShoppingBasket2Fill size={24} />, color: 'bg-custom_red', title: 'Novo Pedido', to: '/novacompra', disabled: false },
            { icon: <BiUser size={24} />, color: 'bg-custom_green', title: 'Perfil', to: `/aluno/${effectiveLogin}`, disabled: false },
        ],
        PARENT: [
            { icon: <RiShoppingBasket2Fill size={24} />, color: 'bg-custom_red', title: 'Novo Pedido', to: '/novacompra/responsavel', disabled: false },
            { icon: <MdOutlineEventNote size={24} />, color: 'bg-custom_red', title: 'Pedidos/Reservas', to: '/reservas/responsavel', disabled: false },
            { icon: <MdMenuBook size={24} />, color: 'bg-custom_blue', title: 'Cardápio', to: '/cardapio', disabled: false },
            { icon: <BiUser size={24} />, color: 'bg-custom_green', title: 'Perfil', to: `/clientes/detalhesResponsavel/${effectiveLogin}`, disabled: false },
            { icon: <MdOutlineAttachMoney size={24} />, color: 'bg-custom_yellow', title: 'Financeiro', to: `/financeiroCliente/${effectiveLogin}`, disabled: false },
        ],
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const currentMenuItems = userRole ? menuItemsByRole[userRole] : [];

    return (
        <div>
            <div>
                <button
                    onClick={toggleMenu}
                    className="p-3 bg-side_menu rounded-full text-white focus:outline-none hover:bg-opacity-90 transition-opacity shadow-md"
                    aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
                >
                    {isMenuOpen ? <AiOutlineClose size={24} /> : <AiOutlineMenu size={24} />}
                </button>
            </div>

            <div
                className={`
                    fixed inset-y-0 left-0 bg-side_menu w-3/4 sm:w-1/2 md:max-w-xs 
                    transform transition-transform duration-300 ease-in-out z-50 shadow-2xl
                    ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'}
                `}
            >
                <div className="flex justify-end p-4">
                    <button onClick={toggleMenu} className="text-white md:hidden">
                        <AiOutlineClose size={24} />
                    </button>
                </div>

                <div className="flex flex-col px-4 pt-4 h-full overflow-y-auto pb-20">
                    {(!userRole || currentMenuItems?.length === 0) && (
                        <div className="text-white text-center p-4 opacity-70">
                            <p>Carregando menu...</p>
                        </div>
                    )}

                    {currentMenuItems?.map((item, index) => (
                        <Link
                            to={!item.disabled ? item.to : '#'}
                            key={index}
                            onClick={!item.disabled ? toggleMenu : undefined}
                            className="block"
                        >
                            <button
                                className={`
                                    w-full flex items-center p-4 my-2 rounded-xl transition-all duration-200 shadow-sm
                                    ${item.disabled
                                        ? 'bg-slate-500/50 cursor-not-allowed opacity-60'
                                        : `${item.color} hover:brightness-110 hover:translate-x-1 active:scale-95`
                                    }
                                `}
                                disabled={item.disabled}
                            >
                                <div className="text-white flex-shrink-0">
                                    {item.icon}
                                </div>
                                <span className="ml-4 font-semibold text-lg text-white tracking-wide">
                                    {item.title}
                                </span>
                            </button>
                        </Link>
                    ))}
                </div>
            </div>

            {isMenuOpen && (
                <div
                    className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 transition-opacity"
                    onClick={toggleMenu}
                    aria-hidden="true"
                ></div>
            )}
        </div>
    );
};

export default TopMenu;